import React from 'react';
import styled from 'styled-components';
import { system, extractSysProps } from './system';

export type BoxProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
  as?: any;
  [key: string]: any;
};

interface StyledBoxInternalProps {
  $sys: Record<string, any>;
  [key: string]: any;
}

const StyledBox = styled.div<StyledBoxInternalProps>`
  ${(p: any) => system(p.$sys, p.theme)}
`;

const Box: React.FC<BoxProps> = ({ children, ...props }) => {
  const { sys, rest } = extractSysProps(props);

  return (
    <StyledBox $sys={sys} {...rest}>
      {children}
    </StyledBox>
  );
};

Box.displayName = 'Box';

export default Box;
